<template>
  <div class="status-value">
    <status-dot :status="status" class="q-mr-md"/>
    <span v-if="!hideLabel" class="ellipsis">{{label}}</span>
    <q-tooltip v-if="label" class="bg-neutral-80 text-white" anchor="top middle" self="top middle">
      {{ label }}
    </q-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDot () {
      return this.status !== 'uncompleted'
    }
  }
}
</script>
